<template>
            <!-- Breadcrumbs (full-width header style) -->
            <nav aria-label="breadcrumb"
               class="bg-sa-breadcrumb text-white py-2">
               <ol class="breadcrumb mb-0">
                  <li>&nbsp;&nbsp;&nbsp;&nbsp;<span class="bg-sa-breadcrumb-icon"><i class="fa fa-refresh"></i></span> &nbsp;&nbsp;</li>
                  <li><a href="#" class="bg-sa-breadcrumb-text">Dashboard</a></li>
                  <li><a href="#" class="bg-sa-breadcrumb-text">Users</a></li>
                  <li class="bg-sa-breadcrumb-text" aria-current="page">
                     All Users
                  </li>
                  <li class="breadcrumb-item ms-auto position-relative">
                     <!--<span class="spinner-border spinner-border-sm text-info ms-auto"></span>-->
                     <div class="gear-wrapper position-relative d-inline-block">
                        <span id="gearBadge" class="gear-badge p-2" @click="syncGearChecks">
   <i id="gearIcon" class="fa fa-cogs fa-lg fa-spin txt-color-blueDark text-black"></i>
</span>
                        <!-- Vertical rectangle panel -->
                        <div id="gearPanel" class="gear-panel">
                           <div class="gear-panel-top"></div>
                           <div class="gear-panel-content">
                              <!-- Layout -->
                              <h6 class="gear-title">Layout Options</h6>
                              <label class="gear-check">
                                 <input id="menuOnTop" type="checkbox" />
                                 <span>Menu on <b>top</b></span>
                              </label>
                              <label class="gear-check">
                                 <input id="toggleHeader" v-model="fixedHeader" type="checkbox" @change="applyFixedBars" />
                                 <span>Fixed Header</span>
                              </label>
                              <label class="gear-check">
                                 <input id="toggleFooter" v-model="fixedFooter" type="checkbox" @change="applyFixedBars" />
                                 <span>Fixed Footer</span>
                              </label>

                              <!-- App Options (this browser only; saved in the browser) -->
                              <h6 class="gear-title">App Options</h6>
                              <label class="gear-check">
                                 <input v-model="$deviceSettings.soundsEnabled" type="checkbox" @change="saveDeviceSetting('soundsEnabled')" />
                                 <span>Sounds</span>
                              </label>
                              <label class="gear-check">
                                 <input v-model="$deviceSettings.showSampleButton" type="checkbox" @change="saveDeviceSetting('showSampleButton')" />
                                 <span>Show "Add sample" button</span>
                              </label>

                              <!-- The rest of the App Options (closed by default) -->
                              <button type="button" class="gear-group-toggle" @click="showAppOptions = !showAppOptions">
                                 <span>More options</span>
                                 <i class="fa" :class="showAppOptions ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                              </button>
                              <div v-show="showAppOptions" class="gear-group">
                                 <label class="gear-check">
                                    <input v-model="$deviceSettings.searchWithButtonClick" type="checkbox" @change="saveDeviceSetting('searchWithButtonClick')" />
                                    <span>Search only on button / Enter</span>
                                 </label>
                                 <label class="gear-check">
                                    <input v-model="$deviceSettings.toastAlerts" type="checkbox" @change="saveDeviceSetting('toastAlerts')" />
                                    <span>Toast-style messages</span>
                                 </label>
                                 <label class="gear-check">
                                    <input v-model="$deviceSettings.focusFirstFieldOnDesktop" type="checkbox" @change="saveDeviceSetting('focusFirstFieldOnDesktop')" />
                                    <span>Focus first field when a form opens (desktop)</span>
                                 </label>
                                 <label class="gear-check">
                                    <input v-model="$deviceSettings.showStatusIcons" type="checkbox" @change="saveDeviceSetting('showStatusIcons')" />
                                    <span>Icons on status tabs</span>
                                 </label>

                                 <label class="gear-label">Form style</label>
                                 <select v-model="$deviceSettings.formStyle" class="form-select form-select-sm mb-2" @change="saveDeviceSetting('formStyle')">
                                    <option value="icons">Label above, with icons</option>
                                    <option value="plain">Label above, no icons</option>
                                    <option value="floating">Label inside the box</option>
                                 </select>

                                 <label class="gear-label">Form tooltips</label>
                                 <select v-model="$deviceSettings.formTooltipMode" class="form-select form-select-sm mb-2" @change="saveDeviceSetting('formTooltipMode')">
                                    <option value="invalid">Only when a box is wrong</option>
                                    <option value="focusAndInvalid">Also when clicking into a box</option>
                                 </select>

                                 <label class="gear-label">Messages position</label>
                                 <select v-model="$deviceSettings.alertPosition" class="form-select form-select-sm mb-2" @change="saveDeviceSetting('alertPosition')">
                                    <option value="top">Top of the page</option>
                                    <option value="bottom">Bottom of the screen</option>
                                 </select>

                                 <label class="gear-label">Records per page</label>
                                 <select v-model.number="$deviceSettings.recordsPerPage" class="form-select form-select-sm mb-2" @change="saveDeviceSetting('recordsPerPage')">
                                    <option :value="5">5</option>
                                    <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                 </select>

                                 <button type="button" class="btn btn-sm btn-outline-secondary w-100 mt-1" @click="resetDeviceSettings">
                                    <i class="fa fa-undo me-1"></i>Reset to defaults
                                 </button>
                              </div>

                              <!-- Skins (in groups: one group open at a time) -->
                              <h6 class="gear-title">Skins</h6>

                              <!-- Smart Glass skins (main group: open by default) -->
                              <button type="button" class="gear-group-toggle" @click="toggleSkinGroup('glass')">
                                 <span>Smart Glass</span>
                                 <i class="fa" :class="openSkinGroup === 'glass' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                              </button>
                              <div v-show="openSkinGroup === 'glass'" class="gear-group">
                                 <button id="smartglassThemeBtn" type="button" class="gear-skin skin-smartglass">Smart Glass</button>
                                 <button id="smartglassRedThemeBtn" type="button" class="gear-skin skin-smartglassred">Smart Glass Red</button>
                                 <button id="smartglassBlueThemeBtn" type="button" class="gear-skin skin-smartglassblue">Smart Glass Blue</button>
                                 <button id="smartglassGreenThemeBtn" type="button" class="gear-skin skin-smartglassgreen">Smart Glass Green</button>
                                 <button id="smartglassBlackThemeBtn" type="button" class="gear-skin skin-smartglassblack">Smart Glass Black</button>
                                 <button id="smartglassYellowThemeBtn" type="button" class="gear-skin skin-smartglassyellow">Smart Glass Yellow</button>
                                 <button id="smartglassWhiteThemeBtn" type="button" class="gear-skin skin-smartglasswhite">Smart Glass White</button>
                                 <button id="smartglassSkyblueThemeBtn" type="button" class="gear-skin skin-smartglassskyblue">Smart Glass Sky Blue</button>
                                 <button id="smartglassGreyThemeBtn" type="button" class="gear-skin skin-smartglassgrey">Smart Glass Grey</button>
                                 <button id="smartglassGreywhiteThemeBtn" type="button" class="gear-skin skin-smartglassgreywhite">Smart Glass Grey White</button>
                              </div>

                              <!-- Standard skins -->
                              <button type="button" class="gear-group-toggle" @click="toggleSkinGroup('standard')">
                                 <span>Standard</span>
                                 <i class="fa" :class="openSkinGroup === 'standard' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                              </button>
                              <div v-show="openSkinGroup === 'standard'" class="gear-group">
                                 <button id="defaultThemeBtn" type="button" class="gear-skin skin-default">Default</button>
                                 <button id="smartThemeBtn" type="button" class="gear-skin skin-smart">Smart</button>
                                 <button id="darkThemeBtn" type="button" class="gear-skin skin-dark">Dark</button>
                                 <button id="blueThemeBtn" type="button" class="gear-skin skin-blue">Blue</button>
                                 <button id="redThemeBtn" type="button" class="gear-skin skin-red">Red</button>
                                 <button id="darkredThemeBtn" type="button" class="gear-skin skin-darkred">Dark Red</button>
                                 <button id="classicwhiteThemeBtn" type="button" class="gear-skin skin-classicwhite">Classic White</button>
                                 <button id="greywhiteThemeBtn" type="button" class="gear-skin skin-greywhite">Grey White</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </li>
               </ol>
            </nav>
            <!-- End Breadcrumbs (full-width header style) -->	
</template>
<script>
export default {
   name: "Breadcrumbs",
   data() {
      return {
         // Ticked = the bar stays on screen; unticked = it scrolls away with the page (default)
         fixedHeader: localStorage.getItem("fixedHeader") === "1",
         fixedFooter: localStorage.getItem("fixedFooter") === "1",

         // App Options: closed by default (the values live in main.js: this.$deviceSettings)
         showAppOptions: false,

         // Skins: the open group ("glass" or "standard"). Smart Glass is open by default;
         // Standard opens instead only when the saved skin is a Standard one
         openSkinGroup: !localStorage.getItem("theme") || localStorage.getItem("theme").startsWith("saglass") ? "glass" : "standard",
      };
   },
   mounted() {
      this.applyFixedBars();
      this.syncGearChecks();
   },
   methods: {
      // Tick the layout checkboxes to match what is on the screen now
      syncGearChecks() {
         const menuTop = document.getElementById("menuOnTop");

         if (menuTop) {
            menuTop.checked = document.body.classList.contains("menu-top-active");
         }
      },
      // App Options: save one choice for this browser; it applies at once (no reload)
      saveDeviceSetting(key) {
         this.$saveDeviceSetting(key, this.$deviceSettings[key]);
      },
      // App Options: forget this browser's choices (back to the main.js values)
      resetDeviceSettings() {
         this.$resetDeviceSettings();
      },
      // Skins: open a group (and close the other); clicking the open one closes it
      toggleSkinGroup(group) {
         this.openSkinGroup = this.openSkinGroup === group ? null : group;
      },
      // Fixed Header / Fixed Footer ticks: apply and remember
      applyFixedBars() {
         document.body.classList.toggle("header-static", !this.fixedHeader);
         document.body.classList.toggle("footer-static", !this.fixedFooter);
         localStorage.setItem("fixedHeader", this.fixedHeader ? "1" : "0");
         localStorage.setItem("fixedFooter", this.fixedFooter ? "1" : "0");
      },
   },
};
</script>